document.addEventListener("DOMContentLoaded", () => {
    const animatedItems = [
        {
            element: ".hero__title",
            animatedValue: "0",
            type: "translate",
            delay: "200",
            animatedClass: "hero__title--animated",
        },
        {
            element: ".hero__title--second",
            animatedValue: "0",
            type: "translate",
            delay: "200",
            animatedClass: "hero__title--animated",
        },
        {
            element: ".hearing-aid-animated",
            type: "animate.css",
            delay: "100",
            animation: "fadeInUp",
        },
    ];

    const initAnimation = () => {
        !sessionStorage.getItem("animationsRan") ? setTimeout(animateItems, 1500) : animateItems();
    };

    const animateItems = () => {
        animatedItems.forEach((item) => {
            switch (item.type) {
                case "translate":
                    let animatedText = document.querySelector(item.element);
                    animatedText &&
                        setTimeout(() => {
                            animatedText.style.transform = `translateY(${item.animatedValue})`;
                            animatedText.style.opacity = "1";
                        }, item.delay);
                    break;

                case "animate.css":
                    let animatedItem = document.querySelector(item.element);
                    animatedItem &&
                        setTimeout(() => {
                            animatedItem.style.opacity = "1";
                            animatedItem.classList.add("animated");
                            animatedItem.classList.add(item.animation);
                        }, item.delay);
            }
        });
    };

    initAnimation();

    /* Parallax effects */

    const targetsArray = [
        {
            elements: document.querySelectorAll(".page-template-horizon .bullet-parallax"),
            rate: window.matchMedia("(max-width: 600px)").matches ? 1 : 0.2,
        },
    ];

    targetsArray.forEach((targets) => {
        targets &&
            window.addEventListener("scroll", (e) => {
                let rateValue = targets["rate"];
                targets["elements"].forEach((target) => {
                    let targetRect = target.getBoundingClientRect();
                    let rate = (targetRect.y - window.innerHeight) * rateValue;
                    if (window.scrollY >= targetRect.top - target.offsetHeight) {
                        target.style.transform = `translateY(${rate}px)`;
                    }
                });
            });
    });

    /* Bullet skip effect */

    const bullets = document.querySelectorAll(".page-template-horizon .bullet-skip");
    let order = [];
    bullets.forEach((bullet, index) => {
        order.unshift(index);
    });

    bullets.forEach((target, index) => {
        target &&
            window.addEventListener("scroll", (e) => {
                let targetRect = target.getBoundingClientRect();
                if (window.scrollY >= targetRect.top - target.offsetHeight) {
                    let displayBullet = targetRect.top - window.innerHeight / 2;
                    bullets[order[index]].style.visibility = displayBullet < 0 && displayBullet > (target.offsetHeight + 20) * -1 ? "visible" : "hidden";
                }
            });
    });
});
